// import { createMedia } from '@artsy/fresnel'
import React, { useState, useEffect } from 'react'
// import Button from 'react-bootstrap/Button';
import styled, { keyframes } from "styled-components";
import Image from 'assets/uiux/gradient.png';
import {Link} from "react-router-dom"
import "./index.css";

import icons from "assets/icons"

import {
  MarketingFooter 
 } from '../../ui-components';
  
 

function Lending() {

    const [top, setTop] = useState(true);

    // detect whether user has scrolled the page down by 10px 
    useEffect(() => {
      const scrollHandler = () => {
        window.pageYOffset > 10 ? setTop(false) : setTop(true)
      };
      window.addEventListener('scroll', scrollHandler);
      return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);  

  return (
    <>


    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top && 'bg-white backdrop-blur-sm shadow-lg'}`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Site branding */}
          <div className="flex-shrink-0 mr-4">
            {/* Logo */}
            <Link to="/" className="block" aria-label="Cruip">
              <svg className="w-8 h-8" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <radialGradient cx="21.152%" cy="86.063%" fx="21.152%" fy="86.063%" r="79.941%" id="header-logo">
                    <stop stopColor="#4FD1C5" offset="0%" />
                    <stop stopColor="#81E6D9" offset="25.871%" />
                    <stop stopColor="#338CF5" offset="100%" />
                  </radialGradient>
                </defs>
                <rect width="32" height="32" rx="16" fill="url(#header-logo)" fillRule="nonzero" />
              </svg>
            </Link>
          </div>

          {/* Site navigation */}
          <nav className="flex flex-grow">
            <ul className="flex flex-grow justify-end flex-wrap items-center">
              {/* <li>
                <Link to="/signin" className="font-medium text-gray-600 hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out">Sign in</Link>
              </li>
              <li>
                <Link to="/signup" className="btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3">
                  <span>Sign up</span>
                  <svg className="w-3 h-3 fill-current text-gray-400 flex-shrink-0 ml-2 -mr-1" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z" fillRule="nonzero" />
                  </svg>                  
                </Link>
              </li> */}
            </ul>

          </nav>

        </div>
      </div>
    </header>


    <section className="relative">
      {/* Illustration behind hero content */}
      <div className="absolute left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Hero content */}
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          {/* Section header */}
          <div className="text-center pb-12 md:pb-16">
            <h1 className="text-5xl md:text-6xl font-extrabold leading-tighter tracking-tighter mb-4" data-aos="zoom-y-out">
              Make your functions <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">quickly</span>
            </h1>
            <div className="max-w-3xl mx-auto">
              <p className="text-xl text-gray-600 mb-8" data-aos="zoom-y-out" data-aos-delay="150">
                코드를 빠르게 배포하고, 쉽게 관리하세요.<br/>
              </p>
            </div>
          </div>

          {/* Hero image */}
          <div>
            <div className="relative flex justify-center mb-8" data-aos="zoom-y-out" data-aos-delay="450">
              <div className="flex flex-col justify-center">
                {/* <img className="mx-auto" src={HeroImage} width="768" height="432" alt="Hero" /> */}

              </div>
              <Link to="/manage">
              
              <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-4 px-4 rounded-full text-xl text-gray-600 mb-8">
                시작하기
              </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div style={{margin:"0px auto", textAlign:"center"}}>
     <h3>별도의 셋팅없이 코드와 스케줄을 입력하면 바로 시작할 수 있습니다.</h3>
    </div>

    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div style={{width:"80%", margin:"40px auto"}}>
        <img src="https://uploads-ssl.webflow.com/628307c2d00556f6126ace8f/631b7cbae5b4f689d76b368f_jobs_webp.webp" alt='sample'></img>
      </div>
    </div>
    {/* <HeroLayout1 style={{margin:"0px auto"}}/> */}
    
    </>
  );
}

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
`

const Background = styled.div`
  /* position: relative; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${Image});
  /* background-size: cover; */
`;

const MainTitle = styled.div`
    font-size: 50px;
    text-align: center;
    color: black;
    font-weight: 700;

    @media screen and (max-width: 500px){
        font-size: 30px;
    }

`

const Landingspacer = styled.div`

    margin-top: 150px;

    @media screen and (max-width: 500px){
        margin-top: 100px;
    }
`

const SubTitle = styled.div`
    font-size: 25px;
    text-align: center;
    color: black;
    font-weight: 700;

    @media screen and (max-width: 500px){
        font-size: 17px;
    }

`


export default Lending;

